module.exports = __webpack_public_path__ + "img/banner.9cd3ab85.png";